import React, { useEffect, useState } from "react";
import client from "../client/client";

// import InputRadio from "../InputRadio/InputRadio";
import InputMultipleRadio from "../InputMultipleRadio/InputMultipleRadio";
import InputCheckbox from "../InputCheckbox/InputCheckbox";

import PrewButton from "../PrewButton/PrewButton";
// import NextButton from "../NextButton/NextButton";
import FinishButton from "../FinishButton/FinishButton";

function Step2(props) {
  const {
    task,
    setTask,
    setStep,

    name,
    surname,
    email,
    phone,
    telegram,
    dataAgreement,

    participationType,
    city,
    place,
    haveIp,
    inn,
    specialization,
    expiration,
    portfolio,
    format,
    command,

    position,
    companyName,
    legalName,
    special,
    otherSpecial,
    ogrn,
    site,
    companyExpiration,
    comapanyCommand,
    addMaterials,

    agree,
    setAgree,
  } = props;

  const [currentTasks, setCurrentTasks] = useState([]);
  const [formErrors, setFormErrors] = useState(null);

  const submitHandler = (event) => {
    event.preventDefault();

    let url;
    let data;

    if (participationType === "1") {
      url = `/full_individual/`;

      let ip = haveIp === "1" ? true : false;

      data = {
        name: name,
        f_name: surname,
        email: email,
        phone: phone,
        telegram: telegram,
        participation: dataAgreement,

        city: city,
        place: place,
        have_ip: ip,
        inn: inn,
        specialization: specialization,
        expiration: expiration,
        portfolio: portfolio,
        format: format,
        command: command,

        agree: agree,
        tasks: task,
      };
    }

    if (participationType === "2") {
      url = `/full_command/`;
      data = {
        name: name,
        f_name: surname,
        email: email,
        phone: phone,
        telegram: telegram,
        participation: dataAgreement,

        position: position,
        company_name: companyName,
        legal_name: legalName,
        special: special.value,
        other_special: otherSpecial,
        ogrn: ogrn,
        site: site,
        expiration: companyExpiration,
        command: comapanyCommand,
        add_materials: addMaterials,

        agree: agree,
        tasks: task,
      };
    }

    client
      .post(url, data)
      .then((res) => {
        setStep(7);
      })
      .catch((error) => {
        console.log(error);
        if (error.response?.status === 400) {
          setFormErrors(error.response.data);
        }
      });
  };

  useEffect(() => {
    const url = `/current_step/`;
    client
      .get(url)
      .then((res) => {
        const recievedTasks = res.data.tasks;
        let tasks = [];

        for (var i = 0; i < recievedTasks.length; i++) {
          let newTask = {
            value: recievedTasks[i].id,
            title: recievedTasks[i].title,
            helpText: recievedTasks[i].description,
          };

          tasks.push(newTask);
        }

        setCurrentTasks(tasks);
      })
      .catch((error) => {
        alert("Произошла ошибка. Попробуйте перезагрузить страницу");
      });
  }, [setStep]);

  return (
    <form action="." onSubmit={submitHandler}>
      <div className="mm-form__inner">
        <InputMultipleRadio
          title=""
          choices={currentTasks}
          name="tasks"
          onChange={setTask}
          value={task}
          error={formErrors?.tasks}
        />
        <InputCheckbox
          title="Я внимательно прочитал и соглашаюсь с <a href='https://create.travelhub.moscow/statement' target='_blank'>Положением о проведении конкурса</a>"
          value={agree}
          onChange={setAgree}
          name="agree"
          error={formErrors?.agree}
        />
      </div>

      <div className="buttons-wrapper">
        <PrewButton
          onClick={() => {
            setStep(3);
          }}
        />
        {/*<NextButton disabled={task ? false : true} onClick={() => setStep(5)} />*/}
        <FinishButton
          type="submit"
          disabled={!(task.length && agree)}
          text="Подать заявку"
        />
      </div>
    </form>
  );
}

export default Step2;
